import api from '../../api/apiSettings'
import actions from './settingActions'

// Получение списка операторов системы
export const getOperators = () => async (dispatch: any) => {
    const responce = await api.getOperators()

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSettingOperators(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Добавление оператора
export const addOperator = (operatorData: any) => async (dispatch: any) => {
    const responce = await api.addOperator(operatorData)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getOperators())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Изменение данных оператора
export const updateOperatorData = (operatorID: number, fieldType: string, fieldValue: string, operatorFIO: any) => async (dispatch: any) => {
    const responce = await api.updateOperatorData(operatorID, fieldType, fieldValue, operatorFIO)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getOperators())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Изменение уровня доступа оператора
export const editAccessLevel = (operatorID: string, accessLevelID: string, isChecked: boolean, newOperatorsList: any) => async (dispatch: any) => {
    const responce = await api.editAccessLevel(operatorID, accessLevelID, isChecked)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSettingOperators(newOperatorsList))
                dispatch(getOperators())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение уровней доступа по УМКД
export const getLevelUmkd = (operatorID: number) => async (dispatch: any) => {
    const responce = await api.getLevelUmkd(operatorID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSettingLevelUmkd(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение справочника направлений подготовки
export const getDictDirectionTraining = () => async (dispatch: any) => {
    const responce = await api.getDictDirectionTraining()

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSettingDictDirectionTraining(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение справочника образовательные программы
export const getDictEducationalProgram = (directionTrainingID: number) => async (dispatch: any) => {
    const responce = await api.getDictEducationalProgram(directionTrainingID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSettingDictEducationalProgram(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Удаление прав доступа для оператора по УМКД
export const deleteAccessLevelUmkd = (operatorID: number, directionTrainingID: number, specializationID: number) => async (dispatch: any) => {
    const responce = await api.deleteAccessLevelUmkd(operatorID, directionTrainingID, specializationID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getLevelUmkd(operatorID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Назначение прав доступа для оператора по УМКД
export const addAccessLevelUmkd = (operatorID: number, directionTrainingID: number, specializationID: number) => async (dispatch: any) => {
    const responce = await api.addAccessLevelUmkd(operatorID, directionTrainingID, specializationID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getLevelUmkd(operatorID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение списка распределенных и не распределенных групп
export const getGroups = (operatorID: number) => async (dispatch: any) => {
    const responce = await api.getGroups(operatorID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSettingGroups(responce.data.assignedGroupsList, responce.data.unassignedGroupsList))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Назначение групп оператору (Портфолио студента)
export const addGroups = (operatorID: number, groupNames: any) => async (dispatch: any) => {
    const responce = await api.addGroups(operatorID, groupNames)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getGroups(operatorID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Удаление групп у оператора (Портфолио студента)
export const deleteGroups = (operatorID: number, groupNames: any) => async (dispatch: any) => {
    const responce = await api.deleteGroups(operatorID, groupNames)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getGroups(operatorID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}




// Обновление справочника направлений подготовки
export const editDictDirectionTraining = (newItems: any) => (dispatch: any) => {
    dispatch(actions.setSettingDictDirectionTraining(newItems))
}

// Обновление справочника специализаций
export const editDictEducationalProgram = (newItems: any) => (dispatch: any) => {
    dispatch(actions.setSettingDictEducationalProgram(newItems))
}

// Обновление списка распределенных и не распределенных групп
export const editGroups = (newItemsAssignedGroups: any, newItemsUnassignedGroups: any) => (dispatch: any) => {
    dispatch(actions.setSettingGroups(newItemsAssignedGroups, newItemsUnassignedGroups))
}



// Очистка списка операторов системы
export const clearOperators = () => (dispatch: any) => {
    dispatch(actions.setSettingOperators([]))
}

// Очистка уровней доступа по УМКД
export const clearLevelUmkd = () => (dispatch: any) => {
    dispatch(actions.setSettingLevelUmkd([]))
}

// Очистка справочника направлений подготовки
export const clearDictDirectionTraining = () => (dispatch: any) => {
    dispatch(actions.setSettingDictDirectionTraining([]))
}

// Очистка справочника образовательные программы
export const clearDictEducationalProgram = () => (dispatch: any) => {
    dispatch(actions.setSettingDictEducationalProgram([]))
}

// Очистка списка распределенных и не распределенных групп
export const clearGroups = () => (dispatch: any) => {
    dispatch(actions.setSettingGroups([], []))
}